import type { ProductSubscriptionInfoViewModel } from 'autogen/swagger/all';
import Handle from 'components/expecteddelivery/handle';
import React, { useContext } from 'react';
import type { IStockStatusViewModelMaybe } from 'autogen/swagger/all';
import { SubscriptionContext } from '../hooks/context';
import List from 'components/List';

export default function ProductStockStatusMapper({
    subscriptionPriceInfo,
    stockStatus
}: {
    subscriptionPriceInfo?: ProductSubscriptionInfoViewModel;
    stockStatus?: IStockStatusViewModelMaybe;
}): JSX.Element | null {
    const { subscriptionActive } = useContext(SubscriptionContext);
    const isSubscriptionProduct = !!subscriptionPriceInfo;

    if (isSubscriptionProduct) {
        const { stockStatusSingleBuy, stockStatusSubscription } = subscriptionPriceInfo;

        return (
            <List>
                {stockStatusSingleBuy && !subscriptionActive && <Handle model={stockStatusSingleBuy} />}
                {stockStatusSubscription && subscriptionActive && <Handle model={stockStatusSubscription} />}
            </List>
        );
    }

    if (stockStatus) {
        return (
            <List>
                <Handle model={stockStatus} />
            </List>
        );
    }

    return null;
}
